const BASE_URL = "/api/retention-certificates";

export const useRetentionPaymentsQuery = async () => {
  const res = await fetch(`${BASE_URL}/payments`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useRetentionPaymentByIdQuery = async (paymentId) => {
  const res = await fetch(`${BASE_URL}/payments/${paymentId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useCreateRetentionPaymentMutation = async (body) => {
  const res = await fetch(`${BASE_URL}/payments`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useUpdateRetentionPaymentMutation = async (body) => {
  const res = await fetch(`${BASE_URL}/payments/${body.id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useUpdateRetentionDateMutation = async ({ id, retentionDate }) => {
  const res = await fetch(`${BASE_URL}/payments/${id}/retention-date`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ retentionDate }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.error) {
    throw new Error(data?.error || "Error en la petición");
  }
  return data;
};

export const useDeleteRetentionPaymentMutation = async (id) => {
  const res = await fetch(`${BASE_URL}/payments/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useRetentionCertificateQuery = async (paymentId) => {
  const res = await fetch(`${BASE_URL}/${paymentId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const fetchRetentionByInvoice = async ({
  supplierInvoiceId,
  accountMovementId,
  invoiceNumber,
  supplierId,
  amount,
  date,
} = {}) => {
  const params = new URLSearchParams();
  if (supplierInvoiceId != null) {
    params.set("supplier_invoice_id", String(supplierInvoiceId));
  }
  if (accountMovementId != null) {
    params.set("account_movement_id", String(accountMovementId));
  }
  if (invoiceNumber) params.set("invoice_number", invoiceNumber);
  if (supplierId != null) params.append("supplier_id", String(supplierId));
  if (amount != null) params.append("amount", String(amount));
  if (date) params.append("date", String(date));
  const res = await fetch(`${BASE_URL}/by-invoice?${params.toString()}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const useRetentionCertificateByNumberQuery = async (certificateNumber) => {
  const res = await fetch(`${BASE_URL}/certificate/${certificateNumber}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

